/*
  L'Atelier de Kinaï : « Modifier » un article du panier.
  1. Dans le panier, le lien « Modifier » mémorise l'article (options, quantité) puis ouvre sa fiche.
  2. Sur la fiche, les options Globo sont pré-remplies et le bouton devient « Mettre à jour mon panier ».
  3. Au clic, le nouvel article est ajouté puis l'ancien est retiré : l'article est remplacé, pas doublé.
*/
(function () {
  var KEY = 'kinaiEdit';
  var MAX_AGE = 30 * 60 * 1000; // 30 min

  function store(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }
  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function clear() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* 1. Panier : clic sur « Modifier » */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-kinai-edit]');
    if (!link) return;
    try {
      var data = JSON.parse(link.getAttribute('data-kinai-edit'));
      data.t = Date.now();
      store(data);
    } catch (err) {}
  });

  /* 2. Fiche produit en mode modification */
  var params = new URLSearchParams(window.location.search);
  if (!params.has('kinai_edit')) return;
  var edit = load();
  var handle = (window.location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
  if (!edit || !edit.p || edit.h !== decodeURIComponent(handle) || Date.now() - (edit.t || 0) > MAX_AGE) return;

  function visibleProps(p) {
    // Liquid « properties | json » donne une liste de paires [[nom, valeur], ...]
    if (Array.isArray(p)) {
      var o = {};
      p.forEach(function (pair) { if (pair && pair.length > 1) o[pair[0]] = pair[1]; });
      p = o;
    }
    var out = {};
    Object.keys(p || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && p[k] !== '' && p[k] != null) out[k] = String(p[k]);
    });
    return out;
  }
  function sameProps(a, b) {
    var ka = Object.keys(a).sort(), kb = Object.keys(b).sort();
    if (ka.join('|') !== kb.join('|')) return false;
    return ka.every(function (k) { return a[k] === b[k]; });
  }
  var oldProps = visibleProps(edit.p);
  var oldQty = parseInt(edit.q, 10) || 1;

  var css =
    '.kinai-edit-banner{display:flex;gap:1rem;align-items:flex-start;background:#F2EFE9;border:1.5px solid #D48C70;border-radius:14px;padding:1.2rem 1.4rem;margin:0 0 1.6rem;color:#2A3B30;font-size:1.4rem;line-height:1.45}' +
    '.kinai-edit-banner svg{flex:none;width:2rem;height:2rem;stroke:#B86F53;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;margin-top:.1rem}' +
    '.kinai-edit-banner b{display:block;font-size:1.5rem;margin-bottom:.2rem}' +
    '.kinai-edit-banner a{color:#5E6B62;text-decoration:underline;text-underline-offset:2px;margin-left:.2rem}';

  function showBanner() {
    if (document.querySelector('.kinai-edit-banner')) return;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    var box = document.createElement('div');
    box.className = 'kinai-edit-banner';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13 7l4 4"/></svg>' +
      '<div><b>Tu modifies un article de ton panier</b>Tes choix sont déjà remplis : change ce que tu veux, puis clique sur « Mettre à jour mon panier ».' +
      '<a href="' + (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '" class="kinai-edit-cancel">Annuler</a></div>';
    var anchor = document.querySelector('.product__info-container') || document.querySelector('product-info') || document.querySelector('main');
    if (anchor) anchor.insertBefore(box, anchor.firstChild);
    box.querySelector('.kinai-edit-cancel').addEventListener('click', clear);
  }

  function relabelButton() {
    document.querySelectorAll('product-form button[name="add"], button[name="add"]').forEach(function (b) {
      var span = b.querySelector('span') || b;
      if (!b.disabled) span.textContent = 'Mettre à jour mon panier';
    });
    document.querySelectorAll('[data-k-sticky-btn]').forEach(function (b) {
      b.textContent = 'Mettre à jour';
    });
  }

  function fields(k) {
    return Array.prototype.filter.call(
      document.querySelectorAll('.gpo-element input[data-field-name], .gpo-element textarea[data-field-name], .gpo-element select[data-field-name]'),
      function (el) { return el.dataset.fieldName === k && !el.disabled; }
    );
  }
  function isSet(k, v) {
    var c = fields(k);
    if (!c.length) return null; // champ absent (option plus proposée ou masquée)
    if (c[0].type === 'radio' || c[0].type === 'checkbox') return c.some(function (el) { return el.checked && el.value === v; });
    return c[0].value === v;
  }
  function setField(k, v) {
    var c = fields(k);
    if (!c.length) return;
    if (c[0].type === 'radio' || c[0].type === 'checkbox') {
      var target = c.find(function (el) { return el.value === v; });
      if (target && !target.checked) target.click();
    } else {
      c[0].value = v;
      c[0].dispatchEvent(new Event('input', { bubbles: true }));
      c[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  async function prefill() {
    // Attendre que les options Globo soient prêtes (10 s max)
    for (var t = 0; t < 50 && !document.querySelector('input[name="properties[_gpo_options]"]'); t++) await sleep(200);
    await sleep(400);
    var keys = Object.keys(oldProps);
    // Plusieurs passages : certaines options n'apparaissent qu'après d'autres choix
    for (var pass = 0; pass < 3; pass++) {
      var pending = false;
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i], v = oldProps[k];
        var state = isSet(k, v);
        if (state === true) continue;
        if (state === null) { pending = true; continue; }
        setField(k, v);
        await sleep(250);
      }
      if (!pending) break;
      await sleep(400);
    }
    var qtyInput = document.querySelector('product-form input[name="quantity"], input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = oldQty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    relabelButton();
  }

  /* 3. Remplacer l'ancien article après l'ajout */
  var replacing = false;
  async function removeOldLine() {
    if (replacing) return;
    replacing = true;
    try {
      await sleep(700); // laisser le thème afficher le panier mis à jour
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var line = (cart.items || []).find(function (it) {
        return String(it.variant_id) === String(edit.v) && sameProps(visibleProps(it.properties), oldProps);
      });
      if (line) {
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        var state = await fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - oldQty), sections: sections, sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); });
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          drawer.classList.toggle('is-empty', state.item_count === 0);
        } else if (!drawer) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      }
    } catch (e) {
      console.warn('[Kinaï] Modification du panier :', e);
    }
    clear();
    document.querySelectorAll('.kinai-edit-banner').forEach(function (b) { b.remove(); });
    document.querySelectorAll('[data-k-sticky-btn]').forEach(function (b) { b.textContent = 'Ajouter au panier'; });
    try {
      params.delete('kinai_edit');
      var qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch (e) {}
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && (!init || !init.method || String(init.method).toUpperCase() === 'POST');
    if (isAdd && init && init.body instanceof FormData && oldQty > 1 && !document.querySelector('input[name="quantity"]')) {
      init.body.set('quantity', String(oldQty));
    }
    var p = nativeFetch.apply(this, arguments);
    if (isAdd && !replacing) {
      p.then(function (res) {
        if (res && res.ok) {
          res.clone().json().then(function (data) {
            if (!data || !data.status) removeOldLine();
          }).catch(function () { removeOldLine(); });
        }
      }).catch(function () {});
    }
    return p;
  };

  function start() {
    showBanner();
    relabelButton();
    prefill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Kinaï : couleur de tissu choisie depuis la page collection (?tissu=Rose).
  On la présélectionne dans les options Globo de la fiche produit.
*/
(function () {
  var params = new URLSearchParams(window.location.search);
  var wanted = params.get('tissu');
  if (!wanted || params.has('kinai_edit')) return;
  var tries = 0;
  var t = setInterval(function () {
    var inputs = Array.prototype.filter.call(
      document.querySelectorAll('.gpo-element input[data-field-name]'),
      function (i) { return /tissu/i.test(i.dataset.fieldName || '') && i.value === wanted && !i.disabled; }
    );
    if (inputs.length) {
      clearInterval(t);
      if (!inputs[0].checked) inputs[0].click();
    } else if (++tries > 40) {
      clearInterval(t);
    }
  }, 250);
})();
